<template>
  <v-dialog v-model="dialog" max-width="900" v-on="$listeners">
    <div v-if="cartProduct">
      <v-card>
        <v-card-title :class="classColor(cartProduct.product.rannge.slug)"
                      class="headline white--text text-uppercase font-weight-bold mb-3">
          {{ cartProduct.product|appTranslate('name') }}
        </v-card-title>

        <v-card-text>
          <CartProductForm v-bind:cart-product="cartProduct" v-bind:api-url="apiUrl" v-bind:data="data"
                           ref="cartProductForm" :number-of-days="numberOfDays"/>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions class="d-flex flex-row-reverse">
          <v-btn color="primary validate" class="ml-2" @click="onValid" depressed>
            {{ "validate"|globalTranslate }}
          </v-btn>
          <v-btn color="primary cancel" @click="onCancel" depressed v-if="displayCancel">
            {{ "cancel"|globalTranslate }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import CartProductForm from "@/components/CartProductForm";
import {getClassColor} from "@/utils";

export default {
  name: "CartProductDialog",
  components: {CartProductForm},
  data() {
    return {
      dialog: false,
      valid: true
    }
  },
  methods: {
    classColor(key) {
      return getClassColor(key);
    },
    onCancel() {
      this.$emit("cancel", true);
    },
    onValid() {
      if (this.validateForm()) {
        this.$emit("valid", this.cartProduct);
      } else {
        alert("Le(s) formulaire(s) comportent des erreurs !");
      }
    },
    validateForm() {
      return this.$refs.cartProductForm.validateForm();
    }
  },
  props: {
    apiUrl: {
      type: String,
      required: true
    },
    cartProduct: {
      type: Object,
      require: true
    },
    data: {
      type: Object,
      required: true
    },
    displayCancel: {
      type: Boolean,
      required: false,
      default() {
        return true;
      }
    },
    isActive: {
      type: Boolean,
      required: true
    },
    numberOfDays: {
      type: Number,
      required: true
    },
  },
  watch: {
    isActive: function (newVal) {
      this.dialog = !!newVal;
    }
  }
}
</script>

<style scoped>

</style>
